export default __webpack_public_path__ + "static/media/badge-j-m.1ba71a13.png";